import { Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { fetchAdvancePaymentDetail } from "../util";
import ListComponent from "./ListComponent";
import JodoListing from "./jodoListing/JodoListing";
import styles from "./jodoListing/style.module.scss";
const TribyteVanSFDialog = ({
  isOpen,
  psid,
  applicationId,
  setOpen,
  typeObj,
  getPaymentDetail,
  currentApplicationDetails
}) => {
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    fetchAdvancePaymentDetail(
      typeObj?.key,
      psid,
      applicationId,
      setRows,
      setLoader
    );
  }, []);

  return (
    <Dialog
      open={isOpen}
      PaperProps={{
        sx: {
          minWidth: typeObj == "jodo" ? "90%" : "unset",
          maxWidth: typeObj == "jodo" ? "90%" : "unset",
          borderRadius: "12px",
        },
      }}
      // fullWidth
      // maxWidth="md"
    >
      <div
        className={
          typeObj?.key == "jodo"
            ? `${styles["select-concession-popup-jodo"]}`
            : `${styles["select-concession-popup"]}`
        }
      >
        <div
          className="d-flex mx-3"
          style={{ justifyContent: "space-between" }}
        >
          {/* {loader&& <ALoader/>} */}
          <div>
            <div className="heading-4 color-dark">{typeObj?.value} Details</div>
            <div className="regular-bold">Application ID {applicationId}</div>
          </div>
          <CrossIcon onClick={() => setOpen(false)} />
        </div>

        {typeObj?.key == "jodo" ? (
          <JodoListing
            getPaymentDetail={getPaymentDetail}
            loader={loader}
            setLoader={setLoader}
            rows={rows}
            currentApplicationDetails={currentApplicationDetails}
          />
        ) : (
          <ListComponent loader={loader} rows={rows} type={typeObj?.key} />
        )}
      </div>
    </Dialog>
  );
};
export default TribyteVanSFDialog;
